import { ChangeDetectionStrategy, Component, computed, inject, input, viewChild, ViewEncapsulation } from '@angular/core';
import { NgStyle } from '@angular/common';
import { S1Layout } from '@seven1/model';
import { PlatformService } from '@seven1/angular/ssr';
import { SidebarComponent } from './sidebar';
import { HeaderComponent } from './header';
import { FooterComponent } from './footer';

@Component({
    selector: 's1-layout',
    imports: [HeaderComponent, SidebarComponent, FooterComponent, NgStyle],
    templateUrl: './layout.wrapper.html',
    styleUrl: './layout.wrapper.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 's1-layout',
    }
})
export class LayoutWrapper {
    private _platform = inject(PlatformService);
    private _header = viewChild(HeaderComponent);
    private _footer = viewChild(FooterComponent);

    block = input.required<S1Layout>();
    headerHeight = computed<string>(() => {
        if (this._platform.isBrowser) {
            const headerHeight = this._header()?.elRef.nativeElement?.getBoundingClientRect()?.height;
            if (headerHeight) {
                return headerHeight + 'px';
            }
        }
        return '0';
    });
    footerHeight = computed<string>(() => {
        if (this._platform.isBrowser) {
            const footerHeight = this._footer()?.elRef.nativeElement?.getBoundingClientRect()?.height;
            if (footerHeight) {
                return footerHeight + 'px';
            }
        }
        return '0';
    });
}
